import WorkoutScreen from "./WorkoutScreen";

export default WorkoutScreen;